import React, {useEffect} from 'react'
import {Grid, FormControl, InputLabel, MenuItem, FormHelperText} from '@material-ui/core'
import _ from 'lodash'
import Select from 'react-select'

export default function ChildGroupListField({
  data,
  childOptionList,
  onChange,
  itemSelected,
  tabActive,
}) {
  const isTrue = itemSelected?.reserve_for?.field_id.includes(`${data.id}`)

  useEffect(() => {
    if (isTrue) {
      let selected = itemSelected?.reserve_for?.value_id
      onChange(null, data.key, selected)
    }
    // eslint-disable-next-line
  }, [])

  const onSetOption = (e, data_key) => {
    onChange(null, data_key, e?.value)
  }

  return (
    <Grid item xs={6} className="select-search-container">
      <InputLabel id="demo-mutiple-name-label">
        <small>{data.name}</small>
      </InputLabel>
      <Select
        classNamePrefix="select"
        className="select-search"
        isSearchable={true}
        labelId="demo-mutiple-name-label"
        id="demo-simple-select"
        options={childOptionList}
        placeholder={isTrue ? itemSelected?.reserve_for?.value : data.name}
        onChange={e => {
          onSetOption(e, data.key)
        }}
        isDisabled={isTrue ? true : false}
      />
      <FormHelperText className="ap-textfield">
        {(() => {
          if (
            (tabActive === 'upcoming' && data.is_required) ||
            (tabActive === 'ongoing' && data.is_required_return)
          ) {
            return 'required*'
          } else {
            return 'optional'
          }
        })()}
      </FormHelperText>
    </Grid>
  )
}
